/* oxlint-disable react-hooks-js/immutability */
/* eslint-disable react-hooks/immutability */

import { useTranslation } from '@mint-lib/i18n';
import { useSnapshot } from 'valtio';

import {
  useJourneysListQuery,
  usePlatformsByCampaign,
} from '../../../queries/index.js';
import { Combobox } from '../../atoms/Combobox.jsx';
import { isPlatformFieldRequiredForTemplateDuplicate } from './isPlatformFieldRequiredForTemplateDuplicate.js';
import type { TemplateDuplicationFormState } from './types.js';

type ContextFieldsProps = {
  state: TemplateDuplicationFormState;
};

export const TemplateContextFieldsV1 = ({ state }: ContextFieldsProps) => {
  const { t } = useTranslation('@myn/import-hub');

  const snap = useSnapshot(state);

  const shouldShowPlatformField = isPlatformFieldRequiredForTemplateDuplicate(
    snap.form.granularityLevel,
  );

  const { data: journeysList = [], isLoading: journeysListIsLoading } =
    useJourneysListQuery();

  const {
    data: platformsOfCampaign = [],
    isLoading: platformsOfCampaignIsLoading,
  } = usePlatformsByCampaign(snap.form.journeyId as number, {
    enabled: Boolean(snap.form.journeyId),
  });

  const platformNameFieldValue = platformsOfCampaign.find(
    ({ id }) => String(id) === String(snap.form.platformName),
  );

  return (
    <>
      <Combobox
        withSearch
        label={t('Campaign*')}
        placeholder={t('Select')}
        inputValue={snap.form.journeyName}
        options={journeysList}
        isLoading={journeysListIsLoading}
        getOptionLabel={(option) => option.name}
        getOptionValue={(option) => option.id.toString()}
        onChange={(option) => {
          state.form.journeyId = option.id;
          state.form.journeyName = option.name;
          state.form.platformName = null;
        }}
        inputProps={{ autoComplete: 'off' }}
      />
      {shouldShowPlatformField && (
        <Combobox
          withSearch
          label={t('Platform*')}
          placeholder={t('Select')}
          inputValue={platformNameFieldValue?.name ?? null}
          options={platformsOfCampaign}
          isLoading={platformsOfCampaignIsLoading}
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.id.toString()}
          onChange={(option) => {
            state.form.platformName = option.id;
          }}
          disabled={!snap.form.journeyId}
          inputProps={{ autoComplete: 'off' }}
        />
      )}
    </>
  );
};
